export enum GameAnimatedIconUnloadReason {
    CONTEXT_LOST,
    VIEWPORT_EXIT,
    REQUESTED,
    GAME_OPEN
}

export interface IGameAnimatedIconRequestOptions {
    jsonUrl: string;
    wrapper: HTMLElement;
    size: {width: number; height: number};
    timings: {delay: number; interval: number;};
    onAnimationLoad?(): void;
    onAnimationUnload?(reason: GameAnimatedIconUnloadReason): void;
    onAnimationBeforeUnload?(reason: GameAnimatedIconUnloadReason): void;
}

export interface IGameAnimatedIconRegistrationResult {
    unregister(): void;
}

export interface IGameAnimatedIconsManagerService {
    register(params: IGameAnimatedIconRequestOptions): IGameAnimatedIconRegistrationResult;
}
